/**
 * Kanban-style drag-and-drop editor for footer navigation
 * Uses jQuery UI Sortable with connectWith for cross-list sorting
 */
var Giant = Giant || {}

;(function ($, window, document, undefined) {
    var pluginName = 'giantKanban',
        dataPrefix = 'kanban',
        defaults = {
            columnSelector: '.kanban-column',
            listSelector: '.kanban-list',
            itemSelector: '.kanban-item',
            handle: '.handle',
            placeholder: 'kanban-placeholder',
            columnAttribute: 'data-column',
            indexName: 'index',
            template: '.template',
            confirm: 'Opravdu chcete odebrat tuto položku?',
        }

    function Kanban(element, options) {
        this.scope = element
        this.$scope = $(element)
        this.options = $.extend({}, defaults, options)
        this._defaults = defaults
        this._name = pluginName
        this.counter = -1
        this.init()
    }

    Kanban.prototype = {
        init: function () {
            var self = this

            this.$lists = this.$scope.find(this.options.listSelector)

            // Initialize sortable on each column with connectWith
            this.$lists.sortable({
                handle: this.options.handle,
                placeholder: this.options.placeholder,
                items: '> ' + this.options.itemSelector,
                connectWith: self.$scope.find(this.options.listSelector),
                forcePlaceholderSize: true,
                tolerance: 'pointer',
                cursor: 'grabbing',
                helper: function (e, ui) {
                    // Clone the element and preserve width
                    var $clone = ui.clone()
                    $clone.width(ui.outerWidth())
                    return $clone
                },
                start: function (e, ui) {
                    ui.item.addClass('is-dragging')
                    ui.placeholder.height(ui.item.height())
                },
                stop: function (e, ui) {
                    ui.item.removeClass('is-dragging')
                },
                receive: function (e, ui) {
                    // Update column value when item moves to new column
                    var newColumn = $(this).closest(self.options.columnSelector).data('column')
                    self.updateItemColumn(ui.item, newColumn)
                },
                update: function () {
                    self.$scope.trigger('kanbanchange')
                },
            })

            // Cloner functionality for adding new items
            this.initCloner()

            return this
        },

        initCloner: function () {
            var self = this

            // Store templates for each column
            this.$scope.find(this.options.columnSelector).each(function () {
                var $column = $(this)
                var $template = $column.find(self.options.template)

                if ($template.length) {
                    $column.data('template', $template.text())
                }
            })

            // Add item button
            this.$scope.on('click', '[data-kanban-add]', function (e) {
                e.preventDefault()
                var column = $(this).data('kanban-add')
                self.addItem(column)
            })

            // Remove item button
            this.$scope.on('click', '[data-kanban-remove]', function (e) {
                e.preventDefault()
                var message = $(this).data('kanban-confirm') || self.options.confirm
                if (confirm(message)) {
                    $(this).closest(self.options.itemSelector).remove()
                    self.$scope.trigger('kanbanchange')
                }
            })
        },

        addItem: function (column) {
            var $column = this.$scope.find('[data-column="' + column + '"]')
            var template = $column.data('template')
            var $list = $column.find(this.options.listSelector)

            if (!template) return

            var regexp = new RegExp('\\{' + this.options.indexName + '\\}', 'g')
            var html = template.replace(regexp, this.counter--)
            var $item = $(html)

            $list.append($item)
            $item.trigger('dom:change')
            this.$scope.trigger('kanbanchange')

            return this
        },

        updateItemColumn: function ($item, newColumn) {
            // Update the level hidden input based on column
            // Column 1 = level 1 (primary), Column 2 = level 2 (secondary), Column 3 = level 3 (tertiary)
            var $levelInput = $item.find('[data-column-input]')
            if ($levelInput.length) {
                $levelInput.val(newColumn)
            }
        },
    }

    $.fn[pluginName] = function (options) {
        var dataPrefixLength = dataPrefix.length

        return this.each(function () {
            if (!$.data(this, 'plugin-' + pluginName)) {
                var data = $(this).data(),
                    options = {}

                if (pluginName in data && $.type(data[pluginName]) === 'object') {
                    options = data[pluginName]
                }

                // Parse data-kanban-* attributes
                $.each(data, function (key, value) {
                    if (key.substr(0, dataPrefixLength) === dataPrefix && key !== dataPrefix) {
                        var id = key.substr(dataPrefixLength)
                        id = id.substr(0, 1).toLowerCase() + id.substr(1)
                        options[id] = value
                    }
                })

                $.data(this, 'plugin-' + pluginName, new Kanban(this, options))
            }
        })
    }

    $.fn[pluginName].defaults = defaults

    // Auto-initialize on dom:change and document ready
    $(document).on('dom:change', function (event) {
        $('[data-kanban]', event.target).giantKanban()
    })
    $('[data-kanban]').giantKanban()

    Giant.Kanban = Kanban
})(jQuery, window, document)
